import { RouterProvider } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { createAppTheme, ToastProvider } from '@myhrbox/myhrbox-frontend-core';
import { ResultModalProvider } from 'context/resultModalContext';
import { DialogProvider } from 'context/dialogContext';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import router from './router';
import './assets/style.css';
import 'highlight.js/styles/github.css'; // должен быть единый здесь и на платформе

dayjs.extend(duration);

const App = () => {
  const theme = createAppTheme();
  return (
    <ThemeProvider theme={theme}>
      <ToastProvider>
        <DialogProvider>
          <ResultModalProvider>
            <CssBaseline />
            <RouterProvider router={router} />
          </ResultModalProvider>
        </DialogProvider>
      </ToastProvider>
    </ThemeProvider>
  );
};

export default App;
